export const SEARCH_PREMIER_HOTELS = "Search Premier Hotels";
export const SEARCH_VACATION_RENTALS = "Search Vacation Rentals";
export const CHOOSE_DATES = "Choose Dates";
export const CHECK_IN = "Check-in";
export const CHECK_OUT = "Check-out";
